import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable, Optional } from '@angular/core';

/** Provides a normalized version of the baseHref. It also allows auto mocking. */
@Injectable({ providedIn: 'root' })
export class BaseHrefService {
  /** Exposes the baseHref defined at the app.module and set to '/' if null or undefined  */
  baseHref: string;

  /** Private implementation of the baseHref so it aligns with the internal getters from this service */
  #baseHref: string;

  get assets(): string {
    return `${this.#baseHref}/assets`;
  }

  get config(): string {
    return `${this.assets}/config`;
  }

  get translation(): string {
    return `${this.assets}/i18n`;
  }

  get sprites(): string {
    return `${this.assets}/sprites`;
  }

  constructor(@Inject(APP_BASE_HREF) @Optional() globalBaseHref: string) {
    this.baseHref = !globalBaseHref ? '/' : globalBaseHref;
    this.#baseHref = this.baseHref.endsWith('/')
      ? this.baseHref.slice(0, -1)
      : this.baseHref;
  }
}
